module.exports = __webpack_public_path__ + "img/slotmachine.8dd6dd94.png";